import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export default makeStyles(
  (theme) => ({
    root: {
      borderRadius: theme.shape.borderRadius,
      backgroundColor: COLORS.neutral.white,
      fontFamily: theme.typography.fontFamily,
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'flex-start',
      justifyContent: 'center',
      padding: theme.spacing(1, 2, 1, 3),
      marginTop: theme.spacing(0.5),
      rowGap: theme.spacing(0.5),
      width: '100%',

      pointerEvents: 'auto',

      '&:disabled': {
        borderWidth: 1,
        borderColor: COLORS.neutral.lightGray,

        '& $title': {
          color: COLORS.neutral.lightGray,
        },
      },

      '&:not(:disabled)': {
        '&:hover': {
          backgroundColor: COLORS.gray.gray90,
        },

        '&$selected': {
          backgroundColor: COLORS.primary.silver,
          '& $description': {
            color: COLORS.neutral.darkGray,
          },
        },
      },
    },
    selected: {},

    titleWrapper: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      width: '100%',
    },
    title: {
      textAlign: 'left',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.neutral.darkGray,
      fontWeight: theme.typography.fontWeightMedium,
      maxWidth: 300,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
    description: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(20),
      color: COLORS.neutral.mediumGray,
      textAlign: 'left',
      whiteSpace: 'pre-wrap',
    },
    diamondIcon: {
      position: 'absolute',
      fontSize: theme.typography.pxToRem(26),
      top: 2,
      right: 2,
    },
    divider: {
      background: COLORS.primary.light,
    },
  }),
  { name: 'ButtonGenerationMode' }
);
